import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Link, withRouter } from 'react-router-dom';

import { withStyles } from 'material-ui/styles';
import Drawer from 'material-ui/Drawer';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Divider from 'material-ui/Divider';
import IconButton from 'material-ui/IconButton';
import MenuIcon from 'material-ui-icons/Menu';
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft';
import { MenuItem, MenuList } from 'material-ui/Menu';
import Hidden from 'material-ui/Hidden';

import Navigation from '../Navigation';
import Home from '../Home';
import TextGenerator from '../TextGenerator';
import PasswordGenerator from '../PasswordGenerator';
import SiteGenerator from '../SiteGenerator';
import NotFound from '../NotFound';

import TextGeneratorImage from '../../assets/TextGenerator.jpg';
import PasswordGeneratorImage from '../../assets/PasswordGenerator.jpg';
import SiteGeneratorImage from '../../assets/SiteGenerator.jpg';

const generators = [
	{
		name: 'Text',
		description: 'This generates random lorem ipsum text.',
		link: {
			label: 'Text Generator',
			path: '/generator-text'
		},
		image: TextGeneratorImage
	},
	{
		name: 'Password',
		description: 'This generates strong passwords.',
		link: {
			label: 'Password Generator',
			path: '/generator-password'
		},
		image: PasswordGeneratorImage
	},
	{
		name: 'Site.xml',
		description: 'This generates a Site.xml for Neos CMS.',
		link: {
			label: 'Site Generator',
			path: '/generator-site'
		},
		image: SiteGeneratorImage
	}
];

class App extends Component {
	state = {
		open: false
	};

	handleDrawer = () => {
		this.setState({
			open: !this.state.open
		});
	}

	handleNavigationClick = (path) => {
		this.props.history.push(path);
		this.setState({
			open: false
		});
	}

	render() {
		const { classes, history } = this.props;
		return (
			<div>
				<AppBar position="fixed">
					<Toolbar>
						<Typography variant="title" color="inherit" className={classes.title}>
							<Link to="/" color="inherit" className={classes.link}>Generator-App</Link>
						</Typography>
						<Hidden smUp>
							<IconButton color="inherit" onClick={this.handleDrawer}>
								<MenuIcon />
							</IconButton>
						</Hidden>
						<Hidden xsDown>
							<Navigation items={generators} />
						</Hidden>
					</Toolbar>
				</AppBar>
				<main className={classes.content}>
					<Switch>
						<Route exact path="/" component={() => <Home items={generators} />} />
						<Route path="/generator-text" component={TextGenerator} />
						<Route path="/generator-password" component={PasswordGenerator} />
						<Route path="/generator-site" component={SiteGenerator} />
						<Route component={NotFound} />
					</Switch>
				</main>
				<Drawer anchor="right" open={this.state.open} onClose={this.handleDrawer} classes={{ paper: classes.drawerPaper }}>
					<div>
						<div className={classes.drawerHeader}>
							<IconButton onClick={this.handleDrawer}><ChevronLeftIcon /></IconButton>
						</div>
						<Divider />
						<MenuList>
							<MenuItem onClick={() => this.handleNavigationClick('/')}>Home</MenuItem>
							{generators.map((item, key) => (
								<MenuItem
									key={key}
									onClick={() => this.handleNavigationClick(item.link.path)}
									selected={history.location.pathname === item.link.path}
									>
									{item.link.label}
								</MenuItem>
							))}
						</MenuList>
					</div>
				</Drawer>
			</div>
		);
	}
};

App.propTypes = {
	classes: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired
};

const styles = theme => ({
	title: {
		flex: 1
	},
	link: {
		color: 'inherit',
		textDecoration: 'none'
	},
	hide: {
		display: 'none'
	},
	content: {
		backgroundColor: theme.palette.background.default,
		width: '100vw',
		padding: theme.spacing.unit * 3,
		minHeight: 'calc(100vh - 56px)',
		marginTop: 56,
		[`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
			marginTop: 48,
			minHeight: 'calc(100vh - 48px)'
		},
		[theme.breakpoints.up('sm')]: {
			marginTop: 64,
			minHeight: 'calc(100vh - 64px)'
		}
	},
	drawerPaper: {
		width: '90vw',
		maxWidth: 350
	},
	drawerHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		padding: '0 8px',
		...theme.mixins.toolbar
	}
});

export default withStyles(styles)(withRouter(App));



// WEBPACK FOOTER //
// ./src/components/App/index.js